<template>
  <div :class="[$style['icon-text-container'], $style[`icon-text-container-${size}`]]">
    <!-- 图标区域 -->
    <div :class="$style['icon-wrapper']">
      <img v-if="icon" :src="icon" />
    </div>
    <!-- 文字内容 -->
    <div :class="$style['text-content']" v-if="text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'IconText',
  props: {
    size: {
      type: String,
      default: 'md'
    },
    icon: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="less" module>
.icon-text-container {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
}

.icon-wrapper {
  .background-fill('./images/icon-bg.png');

  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    .size(98%);

    border-radius: 0.2rem;
  }
}

.text-content {
  margin-top: 0.06rem;
  color: #4e56d3;
  text-align: center;
}

.icon-text-container-md {
  .icon-wrapper {
    .size(1.16rem);
  }

  .text-content {
    font-size: 0.18rem;
  }
}

.icon-text-container-sm {
  .icon-wrapper {
    .size(1.04rem);
  }

  .text-content {
    margin-top: 0.1rem;
    font-size: 0.16rem;
  }
}

.icon-text-container-lg {
  .icon-wrapper {
    .size(1.27rem);
  }

  .text-content {
    font-size: 0.3rem;
    font-family: 'Source Han Serif SC Bold';
  }
}
</style>
